import styled, { css } from "styled-components";
import {
    mobile,
    tablet,
    Button,
    desktop,
    PortalFormDescription,
    PortalFormLabel,
    portalColors
} from "src/components";
import Dropzone from "react-dropzone";

// Cancel Button
export const CancelButton = styled(Button)`
    background: #ffffff;
    width: 140px;
    color: ${portalColors.text};
    border: 1px solid ${portalColors.borderStrong};
    height: ${ p => p.height || "42px"};
    border-radius: ${ p => p.borderRadius || "8px"} !important;
    background: ${portalColors.surface};
    opacity: 1;
    box-shadow: none;
`;
// Save Button
export const SaveButton = styled(Button)`
    width: ${ p => p.width || "140px"};
    background: ${ p => p.backgroundColor || "#ffffff"};
    color: ${ p => p.color || "#FFFFFF"};
    border: ${ p => p.border || `1px solid ${portalColors.text}`};
    height: ${ p => p.height || "42px"};
    border-radius: ${ p => p.borderRadius || "8px"} !important;
    background: ${portalColors.text};
    box-shadow: none;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;
// Field and preview container
export const FormContainer = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    width: 100%;
    max-width: ${p => p.maxWidth || "799px"};
    height: ${p => p.height || "100vh"};
    background: ${portalColors.surface};
    box-shadow: 0 18px 36px rgba(29, 42, 89, 0.08);
    overflow: ${p => p.overflow || "auto"};
    overflow-x: hidden; 
    min-height: 5.625rem;
    border-radius: 16px;
    border: 1px solid ${portalColors.border};
    box-sizing: border-box;
    margin-bottom: 2.5rem;
    align-items: center;
    
    ${tablet`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};

    ${mobile`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};

    ${desktop`
        padding: ${p => p.padding || "3rem"};
        flex-direction: column;
    `};
`;
// Main Container use in Main Add Quotes Page
export const MainContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 83.98px;
    width: 100%;

    ${mobile`
        flex-direction: column-reverse;
        padding-right: 20px;
        gap: 20px;
    `};

    ${tablet`
        flex-direction: column-reverse;
        padding-right: 20px;
        gap: 20px;
    `};

    ${desktop`
        flex-direction: row;
        padding-right: 110px;
        gap: 83.98px;
    `};
`;

export const LeftContainer = styled.div`
    width: 100%;
    max-width: 799px;
    position: relative;
    overflow: auto;
`;
export const RightContainer = styled.div`
    width: 100%;
    max-width: 566px;
    overflow: auto;
`;

// Browse field button
export const BrowseFileButton = styled.div`
    width: 140px;
    height: 38px;
    background-color: ${portalColors.text};
    box-shadow: none;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 0.875rem;
    font-family: "Manrope", "Helvetica", sans-serif;
`;
//  Upload Quotes and article image field
export const ImageContainer = styled(Dropzone)`
    height: ${p => p.height || "364px"};
    width: ${p => p.width || "205px"};
    position: relative;
    border: 1px solid ${portalColors.border};
    border-radius: 16px;
    background: ${portalColors.surfaceSoft};
    margin: ${p => p.margin || "0"};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
//  Image below Description field
export const InputDescription = styled(PortalFormDescription)`
    margin: ${p => p.margin || "0.25rem 0 0"};
    color: ${p => p.color === "#808080" ? portalColors.textSoft : p.color || portalColors.mutedText};
    max-width: 100%;
    overflow-wrap: anywhere;
`;

//Text label
export const TextLabel = styled(PortalFormLabel)`
    display: block;
    margin: ${p => p.margin || "0 0 0.45rem"};
    text-align: left;
    color: ${p => p.color === "#612684" ? portalColors.mutedText : p.color || portalColors.text};
    font-size: ${p => p.fontSize || "1rem"};
    font-weight: ${p => p.color === "#612684" && !p.fontWeight && !p.weight ? 500 : p.fontWeight || p.weight || 700};
    line-height: ${p => p.color === "#612684" ? 1.5 : 1.3};
    max-width: 100%;
    overflow-wrap: anywhere;
`;

//  Display Selected Iamge Field
export const ImagePreview = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 14px;
`;
//  Text Area Field
export const TextArea = styled.textarea`
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    font-size: ${p => p.fontSize || "1rem"};
    width: 100%;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    box-shadow: none;
    height: 180px;
    border: 1px solid ${portalColors.borderStrong};
    padding: 10px 20px;
    border-radius: 8px;
    text-align: left;
    font-weight: 400;
    caret-color: #000;
    resize: none;

    ::placeholder {
        color: ${portalColors.textSoft};
        font-weight: 400;
        text-align: left;
        font-size: ${p => p.placeholderSize || "0.875rem"};
    }
    
    &:focus {
        outline: none;
        border: 1px solid ${portalColors.text};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
    };
    
    ${ p => p.isHighlighted && css`
        border: 1px solid red !important;
    `};
`;

export const ErrorMessage = styled.div`
    font-size: 11.5px;
    color: #ff7171;
    font-weight: 500;
    line-height: 12.5px;
    margin: 4px 0 0 4px;

    &:empty {
        display: none;
    }
`;

export const SpinnerContainer = styled.div`
    width: 2.188rem;
`;
